  <div class="card" (click)="navigate()">
    <img [src]="imgSrc" class="card-img-top" alt="{{ title }}" />
    <div class="card-body">
      <h5 class="card-title">{{ title }}</h5>
      <p class="card-text">{{ description }}</p>
    </div>
  </div>
